module.exports = __webpack_public_path__ + "img/tabRight.e3b850bb.png";